import ExtendedBadge from "@/components/ExtendedBadge";
import { statusBadgeVariant, statusLabel } from "@/utils/application-status";
import { format } from "date-fns";
import { Eye,  } from "lucide-react";
import { Link } from "react-router-dom";



interface IProps{
    applicationRegion: string
    applicationZone: string
    applicationStatus: string
    applicationDate: string
    id: string

}



export default function ApplicationTile({...props}:IProps) {

    return (
        <div className="flex justify-around items-center bg-white  shadow-sm rounded-lg p-2 mt-4">
            <div className="font-bold text-sm">{ props.applicationZone}</div>
            <div className="font-light text-gray-400 text-sm">{ format(new Date(props?.applicationDate), "dd/MM/yyyy")}</div>
            <div className="font-light text-gray-400 text-sm">{ props.applicationRegion}</div>
            <div>
            <ExtendedBadge
                    label={statusLabel(props?.applicationStatus) ?? ""}
                    variant={statusBadgeVariant(props?.applicationStatus)} />
            </div>
            <div className="rounded-lg h-8 w-8 flex items-center justify-center border border-gray-200">
                <Link to={`/applications/licences/applications-details/${props.id}`}>
                    <Eye size={20} />

                </Link>
            </div>
        </div>
    )
}